<template>
	<div class="scrollable only-y">
		<el-tabs type="border-card" v-model="activeTab" @tab-click="tabClick">
			<el-tab-pane label="Index" name="index">
				<template>
                    <el-row>
                        <el-col :xl="18" :lg="18" :md="24" :sm="24" :xs="24" justify="end">
                            <template>
                                <el-select v-model="selectedField" placeholder="Select Field" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5">
                                    <el-option
                                    v-for="item in searchFields"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>

                                <el-select @change="handleChangeType" v-model="selectedMessageTypeField" placeholder="Message Type" style="width:130px;" size="mini" :default-first-option="true" class="mb-10 mr-5">
                                    <el-option
                                    v-for="item in messageTypeField"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>

                                <el-select v-model="selectedFilter" @change="handleChangeFilter" placeholder="Filter By" style="width:140px;" size="mini" :default-first-option="true" class="mb-10 mr-5">
                                    <el-option
                                    v-for="itm in filterBy"
                                    :key="itm.value"
                                    :label="itm.label"
                                    :value="itm.value">
                                    </el-option>
                                </el-select>
                                
                                <el-button-group class="mr-10 ml-10">
                                    <el-button type="primary" round size="mini" :loading="loadingReportTable" class="animated fadeInRight" style="background-color: #0047FF;" @click="changeFilter">
                                        Set Filter
                                    </el-button>
                                </el-button-group>
                            </template>
                        </el-col>
                        <el-col style="text-align: right;" :xl="6" :lg="6" :md="24" :sm="24" :xs="24" justify="end">
                            <template>
                                <el-button-group>
                                    <el-button type="primary" round size="mini" :loading="loadingReportDownload" class="animated fadeInRight" style="background-color: #0047FF;" @click="downloadBilling('download')">
                                        DKD Finance Billing
                                    </el-button>
                                </el-button-group>
                            </template>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <div class="row">
                                    <el-row :gutter="10">
                                        <el-col :xs="24" :sm="24" :md="24" :lg="9" :xl="9" v-loading="loadingReportTable">
                                            <el-card style="min-height: 323px;" shadow="none">
                                                <div slot="header" class="clearfix">
                                                    <span>Report Card Score</span>
                                                </div>
                                                <div style="text-align: center; padding-top: 50px;">
                                                    <h1 style="color: #409200;">{{reportCard(tableDataReportList)}} Achieved</h1>
                                                </div>
                                            </el-card>
                                        </el-col>
                                        <el-col :xs="24" :sm="24" :md="24" :lg="15" :xl="15" v-loading="loadingReportTable">
                                            <el-card shadow="none">
                                                <div slot="header" class="clearfix">
                                                    <span>Monthly Report List</span>
                                                </div>
                                                <div style="min-height: 223px;">
                                                    <el-table
                                                    :data="tableDataReportList"
                                                    style="width: 100%">
                                                        <el-table-column
                                                            prop="status"
                                                            label="Status"
                                                            width="150">
                                                            <template slot-scope="props">
                                                                <span :style="{ color: props.row.status.toLowerCase() == 'failed' ? '#E20000' : '#409200'}">{{ props.row.status}}</span>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column
                                                            prop="description"
                                                            label="Description">
                                                        </el-table-column>
                                                    </el-table>
                                                </div>
                                            </el-card>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="10" class="mt-10">
                                        <el-col :xs="24" :sm="24" :md="24" :lg="9" :xl="9" v-loading="loadingReportTable">
                                            <el-card style="min-height: 457px;" :body-style="{padding: '10px' }" shadow="none">
                                                <div slot="header" class="clearfix">
                                                    <span>Meta</span>
                                                </div>
                                                <div>
                                                    <el-table
                                                    :data="tableMeta"
                                                    :cell-class-name="`cell-custom`"
                                                    :show-header="false"
                                                    style="width: 100%; text-align: left;">
                                                    <el-table-column
                                                    fixed="left">
                                                        <template slot-scope="scope">
                                                            <el-row v-if="scope.row.have_data">
                                                                <el-col :span="24">
                                                                    <div class="wa-number"><b>Conversation (Session)</b></div>
                                                                    <el-row>
                                                                        <el-col class="pd-item" :span="24"><span >Business-Initiate</span></el-col>
                                                                        <el-col class="pd-item" :span="24"><span >User-Initiate</span></el-col>
                                                                    </el-row>
                                                                    <el-row>
                                                                        <el-col class="pd-item" :span="24"><span >Total</span></el-col>
                                                                    </el-row>
                                                                </el-col>
                                                                <el-col :span="24">
                                                                    <div class="wa-number"><b>Revenue (Rp)</b></div>
                                                                    <el-row>
                                                                        <el-col class="pd-item" :span="24"><span >Business-Initiate</span></el-col>
                                                                        <el-col class="pd-item" :span="24"><span >User-Initiate</span></el-col>
                                                                    </el-row>
                                                                    <el-row>
                                                                        <el-col class="pd-item" :span="24"><span >Total</span></el-col>
                                                                    </el-row>
                                                                </el-col>
                                                                <el-col :span="24">
                                                                    <div class="wa-number"><b>Active/Pasive WABA (Clients)</b></div>
                                                                    <el-row>
                                                                        <el-col class="pd-item" :span="24"><b>{{dataDashboardMeta.waba_active || 0}}/{{dataDashboardMeta.waba_passive || 0}}</b></el-col>
                                                                    </el-row>
                                                                </el-col>
                                                                <el-col :span="24">
                                                                    <div class="wa-number"><b>Active/Pasive Phone Number</b></div>
                                                                    <el-row>
                                                                        <el-col class="pd-item" :span="24"><b>{{dataDashboardMeta.phone_number_active || 0}}/{{dataDashboardMeta.phone_number_passive || 0}}</b></el-col>
                                                                    </el-row>
                                                                </el-col>
                                                                <el-col :span="24">
                                                                    <div class="wa-number"><b>Traffic (Messages)</b></div>
                                                                    <el-row>
                                                                        <el-col class="pd-item" :span="24"><span >Send</span>
                                                                        </el-col>
                                                                        <el-col class="pd-item" :span="24"><span >Delivered</span>
                                                                        </el-col>
                                                                    </el-row>
                                                                </el-col>
                                                            </el-row>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column>
                                                    <template slot-scope="scope">
                                                            <el-row v-if="scope.row.have_data">
                                                                <el-col :span="24">
                                                                    <div class="wa-number" style="visibility: hidden !important;"><b>Conversation (Session)</b></div>
                                                                    <el-row>
                                                                        <el-col class="pd-item" :span="24"><span >{{dataDashboardMeta.conversation_bi || 0}}</span></el-col>
                                                                        <el-col class="pd-item" :span="24"><span >{{dataDashboardMeta.conversation_ui || 0}}</span></el-col>
                                                                    </el-row>
                                                                    <el-row>
                                                                        <el-col class="pd-item" :span="24"><span >{{dataDashboardMeta.conversation_total || 0}}</span></el-col>
                                                                    </el-row>
                                                                </el-col>
                                                                <el-col :span="24">
                                                                    <div class="wa-number" style="visibility: hidden !important;"><b>Revenue (Rp)</b></div>
                                                                    <el-row>
                                                                        <el-col class="pd-item" :span="24"><span >{{formatPrice(dataDashboardMeta.revenue_bi || 0)}}</span></el-col>
                                                                        <el-col class="pd-item" :span="24"><span >{{formatPrice(dataDashboardMeta.revenue_ui || 0)}}</span></el-col>
                                                                    </el-row>
                                                                    <el-row>
                                                                        <el-col class="pd-item" :span="24"><span >{{formatPrice(dataDashboardMeta.revenue_total || 0)}}</span></el-col>
                                                                    </el-row>
                                                                </el-col>
                                                                <el-col style="visibility: hidden !important;" :span="24">
                                                                    <div class="wa-number"><b>Active/Pasive WABA (Clients)</b></div>
                                                                    <el-row>
                                                                        <el-col class="pd-item" :span="24"><b>{{dataDashboardMeta.waba_active || 0}}/{{dataDashboardMeta.waba_passive || 0}}</b></el-col>
                                                                    </el-row>
                                                                </el-col>
                                                                <el-col style="visibility: hidden !important;" :span="24">
                                                                    <div class="wa-number"><b>Active/Pasive Phone Number</b></div>
                                                                    <el-row>
                                                                        <el-col class="pd-item" :span="24"><b>{{dataDashboardMeta.phone_number_active || 0}}/{{dataDashboardMeta.phone_number_passive || 0}}</b></el-col>
                                                                    </el-row>
                                                                </el-col>
                                                                <el-col :span="24">
                                                                    <div class="wa-number" style="visibility: hidden !important;"><b>Traffic (Messages)</b></div>
                                                                    <el-row>
                                                                        <el-col class="pd-item" :span="24"><span >{{dataDashboardMeta.send || 0}}</span>
                                                                        </el-col>
                                                                        <el-col class="pd-item" :span="24"><span >{{dataDashboardMeta.delivered || 0}}</span>
                                                                        </el-col>
                                                                    </el-row>
                                                                </el-col>
                                                            </el-row>
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                                </div>
                                            </el-card>
                                        </el-col>
                                        <el-col :xs="24" :sm="24" :md="24" :lg="15" :xl="15" v-loading="loadingReportTableDKD">
                                            <el-card :body-style="{padding: '10px' }" shadow="none">
                                                <div slot="header" class="clearfix">
                                                    <span>Damcorp</span>
                                                </div>
                                                <el-row>
                                                    <el-col :span="12">
                                                            <el-table
                                                            :data="tableDKD"
                                                            :cell-class-name="`cell-custom`"
                                                            :show-header="false"
                                                            style="width: 100%; text-align: left;">
                                                            <el-table-column
                                                            width="200"
                                                            fixed="left">
                                                                <template slot-scope="scope">
                                                                    <el-row v-if="scope.row.have_data">
                                                                        <el-col :span="24">
                                                                            <div class="wa-number"><b>Conversation (Session)</b></div>
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24"><span >Business-Initiate</span></el-col>
                                                                                <el-col class="pd-item" :span="24"><span >CBP-BI</span></el-col>
                                                                            </el-row>
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24"><span >Total BI</span></el-col>
                                                                            </el-row>
                                                                        </el-col>
                                                                        <el-col :span="24">
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24"><span >User-Initiate</span></el-col>
                                                                            </el-row>
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24"><span >CBP-UI</span></el-col>
                                                                                <el-col class="pd-item" :span="24"><span >Total UI</span></el-col>
                                                                            </el-row>
                                                                            <div class="wa-number"><b>Total Conversation</b></div>
                                                                        </el-col>
                                                                        <el-col :span="24">
                                                                            <div class="wa-number"><b>Active/Pasive WABA (Clients)</b></div>
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24"><b>{{dataDashboardDKD.waba_active || 0}}/{{dataDashboardDKD.waba_passive || 0}}</b></el-col>
                                                                            </el-row>
                                                                        </el-col>
                                                                        <el-col :span="24">
                                                                            <div class="wa-number"><b>Active/Pasive Phone Number</b></div>
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24"><b>{{dataDashboardDKD.phone_number_active || 0}}/{{dataDashboardDKD.phone_number_passive || 0}}</b></el-col>
                                                                            </el-row>
                                                                        </el-col>
                                                                        <el-col :span="24">
                                                                            <div class="wa-number"><b>Traffic (Messages)</b></div>
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24"><span >Send</span>
                                                                                </el-col>
                                                                                <el-col class="pd-item" :span="24"><span >Delivered</span>
                                                                                </el-col>
                                                                            </el-row>
                                                                        </el-col>
                                                                    </el-row>
                                                                </template>
                                                            </el-table-column>
                                                            <el-table-column
                                                            width="200">
                                                            <template slot-scope="scope">
                                                                    <el-row v-if="scope.row.have_data">
                                                                        <el-col :span="24">
                                                                            <div class="wa-number" style="visibility: hidden !important;"><b>Conversation (Session)</b></div>
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24"><span >{{dataDashboardDKD.conversation_bi || 0}}</span></el-col>
                                                                                <el-col class="pd-item" :span="24"><span >{{dataDashboardDKD.conversation_cbp_bi || 0}}</span></el-col>
                                                                            </el-row>
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24"><span >{{(dataDashboardDKD.conversation_bi || 0) + (dataDashboardDKD.conversation_cbp_bi || 0)}}</span></el-col>
                                                                            </el-row>
                                                                        </el-col>
                                                                        <el-col :span="24">
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24"><span >{{dataDashboardDKD.conversation_ui || 0}}</span></el-col>
                                                                            </el-row>
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24"><span >{{dataDashboardDKD.conversation_cbp_ui || 0}}</span></el-col>
                                                                                <el-col class="pd-item" :span="24"><span >{{(dataDashboardDKD.conversation_ui || 0) + (dataDashboardDKD.conversation_cbp_ui || 0)}}</span></el-col>
                                                                            </el-row>
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24"><span >{{dataDashboardDKD.conversation_total || 0}}</span></el-col>
                                                                            </el-row>
                                                                        </el-col>
                                                                        <el-col style="visibility: hidden !important;" :span="24">
                                                                            <div class="wa-number"><b>Active/Pasive WABA (Clients)</b></div>
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24"><b>0/0</b></el-col>
                                                                            </el-row>
                                                                        </el-col>
                                                                        <el-col style="visibility: hidden !important;" :span="24">
                                                                            <div class="wa-number"><b>Active/Pasive Phone Number</b></div>
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24"><b>0/0</b></el-col>
                                                                            </el-row>
                                                                        </el-col>
                                                                        <el-col :span="24">
                                                                            <div class="wa-number" style="visibility: hidden !important;"><b>Traffic (Messages)</b></div>
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24"><span >{{dataDashboardDKD.send || 0}}</span>
                                                                                </el-col>
                                                                                <el-col class="pd-item" :span="24"><span >{{dataDashboardDKD.delivered || 0}}</span>
                                                                                </el-col>
                                                                            </el-row>
                                                                        </el-col>
                                                                    </el-row>
                                                                </template>
                                                            </el-table-column>
                                                        </el-table>
                                                    </el-col>
                                                    <el-col :span="12">
                                                            <el-table
                                                            :data="tableDKD"
                                                            :cell-class-name="`cell-custom`"
                                                            :show-header="false"
                                                            style="width: 100%; text-align: left;">
                                                            <el-table-column
                                                            width="180"
                                                            fixed="left">
                                                                <template slot-scope="scope">
                                                                    <el-row v-if="scope.row.have_data">
                                                                        <el-col :span="24">
                                                                            <div class="wa-number"><b>Revenue Conversation</b></div>
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24"><span >Business-Initiate</span></el-col>
                                                                                <el-col class="pd-item" :span="24"><span >CBP-BI</span></el-col>
                                                                            </el-row>
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24"><span >Total BI</span></el-col>
                                                                            </el-row>
                                                                        </el-col>
                                                                        <el-col :span="24">
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24"><span >User-Initiate</span></el-col>
                                                                            </el-row>
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24"><span >CBP-UI</span></el-col>
                                                                                <el-col class="pd-item" :span="24"><span >Total UI</span></el-col>
                                                                            </el-row>
                                                                            <div class="wa-number"><b>Total Revenue</b></div>
                                                                        </el-col>
                                                                        <el-col :span="24">
                                                                            <div class="wa-number"><b>Revenue Service Maintenance</b></div>
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24">Chatbot</el-col>
                                                                            </el-row>
                                                                        </el-col>
                                                                        <el-col :span="24">
                                                                            <div class="wa-number"><b>Revenue Service Omnichannel</b></div>
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24">Facebook</el-col>
                                                                                <el-col class="pd-item" :span="24">Instagram</el-col>
                                                                                <el-col class="pd-item" :span="24">Telegram</el-col>
                                                                                <el-col class="pd-item" :span="24">Line</el-col>
                                                                                <el-col class="pd-item" :span="24">Live Chat</el-col>
                                                                            </el-row>
                                                                        </el-col>
                                                                    </el-row>
                                                                </template>
                                                            </el-table-column>
                                                            <el-table-column
                                                            width="180">
                                                            <template slot-scope="scope">
                                                                    <el-row v-if="scope.row.have_data">
                                                                        <el-col :span="24">
                                                                            <div class="wa-number" style="visibility: hidden;"><b>Revenue Conversation</b></div>
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24"><span >{{formatPrice(dataDashboardDKD.revenue_bi || 0)}}</span></el-col>
                                                                                <el-col class="pd-item" :span="24"><span >{{formatPrice(dataDashboardDKD.revenue_cbp_bi || 0)}}</span></el-col>
                                                                            </el-row>
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24"><span >{{formatPrice((dataDashboardDKD.revenue_bi || 0) + ((dataDashboardDKD.revenue_cbp_bi || 0)))}}</span></el-col>
                                                                            </el-row>
                                                                        </el-col>
                                                                        <el-col :span="24">
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24"><span >{{formatPrice(dataDashboardDKD.revenue_ui || 0)}}</span></el-col>
                                                                                <el-col class="pd-item" :span="24"><span >{{formatPrice(dataDashboardDKD.revenue_cbp_ui || 0)}}</span></el-col>
                                                                            </el-row>
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24"><span >{{formatPrice((dataDashboardDKD.revenue_ui || 0) + ((dataDashboardDKD.revenue_cbp_ui || 0)))}}</span></el-col>
                                                                            </el-row>
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24"><span >{{formatPrice(dataDashboardDKD.revenue_total || 0)}}</span></el-col>
                                                                            </el-row>
                                                                        </el-col>
                                                                        <el-col :span="24">
                                                                            <div class="wa-number" style="visibility: hidden;"><b>Revenue Service Maintenance</b></div>
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24">{{formatPrice(dataDashboardChatbotOmni.chatbot || 0)}}</el-col>
                                                                            </el-row>
                                                                        </el-col>
                                                                        <el-col :span="24">
                                                                            <div class="wa-number" style="visibility: hidden;"><b>Revenue Service Omnichannel</b></div>
                                                                            <el-row>
                                                                                <el-col class="pd-item" :span="24">{{formatPrice(dataDashboardChatbotOmni.omnichannel && dataDashboardChatbotOmni.omnichannel.facebook || 0)}}</el-col>
                                                                                <el-col class="pd-item" :span="24">{{formatPrice(dataDashboardChatbotOmni.omnichannel && dataDashboardChatbotOmni.omnichannel.instagram || 0)}}</el-col>
                                                                                <el-col class="pd-item" :span="24">{{formatPrice(dataDashboardChatbotOmni.omnichannel && dataDashboardChatbotOmni.omnichannel.telegram || 0)}}</el-col>
                                                                                <el-col class="pd-item" :span="24">{{formatPrice(dataDashboardChatbotOmni.omnichannel && dataDashboardChatbotOmni.omnichannel.line || 0)}}</el-col>
                                                                                <el-col class="pd-item" :span="24">{{formatPrice(dataDashboardChatbotOmni.omnichannel && dataDashboardChatbotOmni.omnichannel.livechat || 0)}}</el-col>
                                                                            </el-row>
                                                                        </el-col>
                                                                    </el-row>
                                                                </template>
                                                            </el-table-column>
                                                        </el-table>
                                                    </el-col>
                                                </el-row>
                                            </el-card>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="10" class="mt-10">
                                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" :loading="loadingBtnSummary">
                                            <el-card :body-style="{padding: '10px' }" style="min-height: 480px;" shadow="none">
                                                <div slot="header" class="clearfix">
                                                    <span>Quick 3 Years Summary</span>
                                                </div>
                                                <div>
                                                    <el-table
                                                        :data="tableDataSummary"
                                                        :span-method="objectSpanMethodSummary"
                                                        style="width: 100%; margin-top: 20px">
                                                        <el-table-column
                                                            fixed
                                                            prop="year"
                                                            width="70">
                                                        </el-table-column>
                                                        <el-table-column
                                                            fixed
                                                            prop="description"
                                                            width="220">
                                                            
                                                        </el-table-column>
                                                        <el-table-column
                                                            prop="Q_1"
                                                            label="Q1"
                                                            width="220">
                                                        </el-table-column>
                                                        <el-table-column
                                                            prop="Q_2"
                                                            label="Q2"
                                                             width="220">
                                                        </el-table-column>
                                                        <el-table-column
                                                            prop="H_1"
                                                            label="H1"
                                                             width="220">
                                                        </el-table-column>
                                                        <el-table-column
                                                            prop="Q_3"
                                                            label="Q3"
                                                             width="220">
                                                        </el-table-column>
                                                        <el-table-column
                                                            prop="Q_4"
                                                            label="Q4"
                                                             width="220">
                                                            <!-- <template slot-scope="props">
                                                                <p style="font-weight:bold;">{{ !props.row.revenue ? '-':formatPrice(props.row.revenue)}}</p>
                                                            </template> -->
                                                        </el-table-column>
                                                        <el-table-column
                                                            prop="H_2"
                                                            label="H2"
                                                             width="220">
                                                        </el-table-column>
                                                    </el-table>
                                                </div>
                                            </el-card>
                                        </el-col>
                                    </el-row>
                                </div>
                        </el-col>
                    </el-row>
				</template>
			</el-tab-pane>
			<el-tab-pane label="Set Meta Goal" name="set_meta_goal">
				<template>				
                    <div>
                        <el-row>
                            <el-col>
                                <el-button class="mb-10" style="background-color: #3576F2; color: #FFFFFF;" @click="addMetaGoals">Add New Data</el-button>
                            </el-col>
                        </el-row>
                    </div>

                    <template>
                        &nbsp;
                        <el-pagination
                            background
                            prev-text="Prev"
                            next-text="Next"
                            layout="prev, pager, next"
                            :page-size="10"
                            @current-change="paginateMetaGoals"
                            :current-page="currentPageMetaGoals"
                            :total="parseInt(totalMetaGoals)"
                            style="margin-bottom:20px;"/>
                        <el-card v-for="(item,i) in meta_goal_data" :key="i" :body-style="{padding: '10px' }" style="min-height: 480px; margin-bottom: 20px;" shadow="none">
                            <div slot="header" class="clearfix">
                                <span>Set Goal in {{item.year}}</span>
                                 <span v-if='checkYear(item.year) && !item.disabled' style="float:right">
                                    <el-button size="mini" icon="el-icon-edit" type="default" style="background-color:#F7BA2A;" @click="doShowDialogEditMetaGoal(item)"></el-button>
                                    <el-button size="mini" icon="el-icon-delete" type="danger" @click="doDeleteMetaGoal(item)"></el-button>
                                </span>
                            </div>
                            <div>
                                <el-table
                                    v-loading="loadingReportTable"
                                    :data="item.meta_goals"
                                    style="width: 100%; margin-top: 20px">
                                    <el-table-column
                                        prop="goal_name"
                                        label="GOAL Name">
                                    </el-table-column>
                                    <el-table-column
                                        prop="conversation"
                                        label="Conversation">
                                    </el-table-column>
                                    <el-table-column
                                        prop="revenue"
                                        label="Revenue">
                                        <template slot-scope="props">
                                            <p style="font-weight:bold;">{{ !props.row.revenue ? '-':formatPrice(props.row.revenue)}}</p>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="active_waba"
                                        label="Active WABA">
                                    </el-table-column>
                                    <el-table-column
                                        prop="active_number"
                                        label="Active Number">
                                    </el-table-column>
                                </el-table>
                            </div>
                        </el-card>
                        <el-pagination
                            background
                            prev-text="Prev"
                            next-text="Next"
                            layout="prev, pager, next"
                            :page-size="10"
                            @current-change="paginateMetaGoals"
                            :current-page="currentPageMetaGoals"
                            :total="parseInt(totalMetaGoals)"/>
                        <br/>
                    </template>
                </template>
			</el-tab-pane>
			<el-dialog title="Add Data" :visible.sync="dialogAddData" v-loading="loadingLoadAddData" id="html-2-pdfwrapper">
				<el-row>
                    <el-col>
                         <el-table
                            v-loading="loadingLoadAddData"
                            :data="tableDataMetaGoalsAdd"
                            style="width: 100%;">
                            <el-table-column
                                prop="goal_name"
                                label="GOAL Name">
                                <template slot-scope="props">
                                    <p v-if="props.row.goal_name.indexOf('Quarter') > -1 || props.row.goal_name.indexOf('H') > -1" style="font-weight:bold;">{{props.row.goal_name}}</p>
                                    <p v-else>{{props.row.goal_name}}</p>
                                    <!-- <el-input style="width: 90%" placeholder="Please input" v-model="props.row.goal_name"></el-input> -->
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="conversation"
                                label="Conversation">
                                <template slot-scope="props">
                                    <el-input @keypress.native="numberOnly" style="width: 90%" v-model="props.row.conversation"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="revenue"
                                label="Revenue">
                                <template slot-scope="props">
                                    <el-input @keypress.native="numberOnly" style="width: 90%" v-model="props.row.revenue"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="active_waba"
                                label="Active WABA">
                                <template slot-scope="props">
                                    <el-input @keypress.native="numberOnly" style="width: 90%" v-model="props.row.active_waba"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="active_number"
                                label="Active Number">
                                <template slot-scope="props">
                                    <el-input @keypress.native="numberOnly" style="width: 90%" v-model="props.row.active_number"></el-input>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col style="padding : 10px;">
                    <span style="float: right;">
                        <el-button type="primary" @click="addDataMetaGoals" :loading="loadingBtn">Save</el-button>
                        <el-button @click="dialogAddData=false">Cancel</el-button>
                    </span>
                    </el-col>
                </el-row>
			</el-dialog>
            <el-dialog title="Edit Data" :visible.sync="dialogEditData" v-loading="loadingLoadAddData" id="html-2-pdfwrapper">
				<el-row>
                    <el-col>
                         <el-table
                            v-loading="loadingLoadAddData"
                            :data="tableDataMetaGoalsEdit"
                            style="width: 100%;">
                            <el-table-column
                                prop="goal_name"
                                label="GOAL Name">
                                <template slot-scope="props">
                                    <p v-if="props.row.goal_name.indexOf('Quarter') > -1 || props.row.goal_name.indexOf('H') > -1" style="font-weight:bold;">{{props.row.goal_name}}</p>
                                    <p v-else>{{props.row.goal_name}}</p>
                                    <!-- <el-input style="width: 90%" placeholder="Please input" v-model="props.row.goal_name"></el-input> -->
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="conversation"
                                label="Conversation">
                                <template slot-scope="props">
                                    <el-input @keypress.native="numberOnly" style="width: 90%" v-model="props.row.conversation"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="revenue"
                                label="Revenue">
                                <template slot-scope="props">
                                    <el-input @keypress.native="numberOnly" style="width: 90%" v-model="props.row.revenue"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="active_waba"
                                label="Active WABA">
                                <template slot-scope="props">
                                    <el-input @keypress.native="numberOnly" style="width: 90%" v-model="props.row.active_waba"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="active_number"
                                label="Active Number">
                                <template slot-scope="props">
                                    <el-input @keypress.native="numberOnly" style="width: 90%" v-model="props.row.active_number"></el-input>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col style="padding : 10px;">
                    <span style="float: right;">
                        <el-button type="primary" @click="editDataMetaGoals" :loading="loadingBtn">Save</el-button>
                        <el-button @click="dialogEditData=false, paginateMetaGoals(1)">Cancel</el-button>
                    </span>
                    </el-col>
                </el-row>
			</el-dialog>
		</el-tabs>
	</div>
</template>

<script>
import config from '@/config'
import axios from 'axios'
import api from '@/networkClient'
const moment = require('moment')
import store from '@/store'
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable"
import M from 'minimatch'

export default {
  components: {  },
	name: 'DashboardMeta',
	props: {
        dataMeta: {
            type: Object
        },
		dataDashboard: {
            type: Array
        },
        loadingData: {
            type: Boolean
        },
        date: {
            type : Array
        }
    },
    data() {
        return {
            btnDownload: false,
			dataDashboardMeta: {
                "conversation_total": 0,
                "conversation_bi": 0,
                "conversation_ui": 0,
                "revenue_total": 0,
                "revenue_bi": 0,
                "revenue_ui": 0,
                "phone_number_passive": 0,
                "phone_number_active": 0,
                "waba_active": 0,
                "waba_passive": 0,
                "send": 0,
                "delivered": 0
            },
            dataDashboardDKD: {
                "conversation_total": 0,
                "conversation_bi": 0,
                "conversation_cbp_bi": 0,
                "conversation_ui": 0,
                "conversation_cbp_ui": 0,
                "revenue_total": 0,
                "revenue_cbp_bi": 0,
                "revenue_bi": 0,
                "revenue_cbp_ui": 0,
                "revenue_ui": 0,
                "phone_number_active": 0,
                "phone_number_passive": 0,
                "waba_active": 0,
                "waba_passive": 0,
                "send": 0,
                "delivered": 0
            },
            dataDashboardChatbotOmni: {
                "chatbot": 0,
                "omnichannel": {
                    "facebook": 0,
                    "instagram": 0,
                    "telegram": 0,
                    "line": 0,
                    "livechat": 0
                }
            },
            dataDashboardMetaGoals: {
                "id": null,
                "year": null,
                "dateCreate": null,
                "meta_goals": []
            },
            loadingReportDownload: false,
            loadingLoadAddData: false,
            dialogAddData: false,
            dialogEditData: false,
            totalMetaGoals: 0,
            currentPageMetaGoals: 1,
            tableDataMetaGoals:[],
            tableDataMetaGoalsAdd:[
            ],
            tableDataMetaGoalsEdit:[
            ],
            meta_goal_data:[{year: "2022"},{year: "2021"}],
            tableData:[],
            tableDataSummary: [],
            tableMeta: [{
                have_data: true,
            }],
            tableDKD: [{
                have_data: true,
            }],
            tableDataReportList:[
                {
                    status: '',
                    description: ''
                }, {
                    status: '',
                    description: ''
                }, {
                    status: '',
                    description: ''
                }, {
                    status: '',
                    description: ''
                }
            ],
            loadingReportTable: false,
            loadingReportTableDKD: false,
            searchFields: [
                // { value: "phone_number", label: "Phone Number" },
                // { value: "waba_id", label: "WABA ID " }
            ],
            optionsMonths: [],
            selectedField: moment().format("YYYY"),
            filterBy: this.optionsMonths,
            selectedFilter: moment().format("MM"),
            selectedMessageTypeField: "monthly",
            messageTypeField: [
                { value: "monthly", label: "Monthly" },
                { value: "quarter_years", label: "Quarter Years" },
                { value: "half_years", label: "Half Years" },
            ],
			loadingPrint: false,
			submitreq: false,
			loadingLoadBilling: false,
			loadingAddSetting: false,
			loadingSetting: false,
			cusId: "",
			user: {
				name: store.getters.userName,
				company: store.getters.companyName
			},
			products_name: [
				{
					name:'Whatsapp Conversation'
				},{
					name:'Whatsapp Notification'
				}
			],
			products_notif: [
				{
					name:'notification_caping_plafon'
				},{
					name:'notification_caping'
				}
			],
			setting: [],
			settingForm: {
				service_fee_add: 0,
                service_tax_add: 0,
				pph_add: 0,
                service_fee_minus: 0,
                service_tax_minus: 0,
				pph_min: 0
			},
			product: [ { product: [] } ],
			// products_notif: [{name:'cbp_caping'},{name:'cbp_hybrid'}],
			token_type: [{
				name:'CBP',
				value: 'CBP',
				disabled: false
			},{
				name:'UI',
				value: 'UI',
				disabled: false
			}, {
				name: 'BI',
				value: 'BI',
				disabled: false
			}],
			radio: 'Added',
			dialogCheckVisible: false,
			dialogCheckVisibleCaping: false,
			dialogDocumentBilling: false,
			formLabelWidth: '300px',
			formLoading: false,
			loadingDetail: false,
			btnLoading: false,
			loadingBtn: false,
            loadingBtnSummary: false,
			saldoLoading: false,
			pendingLoading: false,
			loadingNumberCaping: false,
			loadingNumber: false,
			loadingPrefix: false,
			loadingApproved: false,
			loadingRejected: false,
			prefix:[],
			detailTopupData: {},
			ruleForm: {
				selectedPhoneNumber: "",
				selectedCompany: "",
				num8: ""
			},
			ruleFormCaping: {
				selectedProductName: "Whatsapp Conversation",
				selectedProduct: "notification_caping_plafon",
				selectedCompany: "",
				selectedPhoneNumber: "",
				topuptype: "Added",
				reason: "",
				detail: [{
					tokenType: "CBP",
					quota_before_topup: 0,
					quota: 0,
					quota_after_topup: 0,
					discount: 0
				},{
					tokenType: "UI",
					quota_before_topup: 0,
					quota: 0,
					quota_after_topup: 0,
					discount: 0
				},{
					tokenType: "BI",
					quota_before_topup: 0,
					quota: 0,
					quota_after_topup: 0,
					discount: 0
				}],
				total_nominal: 0
			},
			rules: {
				selectedProduct: [
					 { required: true, message: 'Please select Product Notif', trigger: 'change' }
				],
				selectedPhoneNumber: [
					 { required: true, message: 'Please select Phone Number', trigger: 'change' }
				],
				selectedCompany: [
					{ required: true, message: 'Please select Company', trigger: 'change' }
				],
				num8: [
					{ required: true, message: 'Please input nominal', trigger: 'blur' },
				],
				// tokenType: [
				// 		{ required: true, message: 'Please select Token Type', trigger: 'change' }
				// ],
				reason: [
					{ required: true, message: 'Please enter reason', trigger: 'change' }
				],
				topuptype: [
					{ required: true, message: 'Please select Topup Type', trigger: 'change' }
				],
				// quota: [
				// 	{ required: true, message: 'Please input quota', trigger: 'blur' },
				// ]
			},
			costumers : [],
			costumersCaping : [],
			total: 0,
			totalCaping: 0,
			dataSaldo: '',
			dataQuota: 0,
			dataQuotaUI: 0,
			dataQuotaBI: 0,
			dataCapingQuota: '',
			historyLoading: false,
			history: [],
			totalHistory: 0,
			pendingRequest: [],
			totalPendingStatus: 0,
			totality: [],
			priceCbp: 0,
			priceUi: 0,
			priceBi: 0,
			totalCbp: 0,
			totalUi: 0,
			totalBi: 0,
			totalBilling: 0,
			totalPrice: 0,
			discountCBP: 0,
			discountUI: 0,
			discountBI: 0,
			activeTab: "index",
			radioOptions: [],
			setting: []
        }
    },
	// components: {
	// 	VueHtml2pdf
	// },
    methods: {
        log(data){
            console.log(data, " <<data");
        },
        reportCard(val){
            if (val.length > 0) {
                let filterAchieved = [...val].filter(el => el.status.toLowerCase() == 'achieved')
    
                return `${filterAchieved.length}/${val.length}`
            }
            
            return `0/0`
        },
        numberOnly(e) {
            var key = window.event ? e.keyCode : e.which;

            let isNumber = _.indexOf([8, 9, 27, 13, 190, 43], e.keyCode)
            if ( isNumber !== -1 ||
                // Allow: Ctrl+C, Command+C
                (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+A, Command+A
                (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: Ctrl+R, Command+R
                (e.keyCode === 82 && (e.ctrlKey === true || e.metaKey === true)) ||
                // Allow: home, end, left, right, down, up
                (e.keyCode > 42 && e.keyCode <= 49 && _.indexOf([44,45,47], e.keyCode) == -1)) {
                // let it happen, don't do anything
                return
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode > 96 || e.keyCode < 200)) {
                e.preventDefault();
            }
        },
        paste(event, field, field2, field3) {
            event.preventDefault()
            var totalCharacterCount = window.event.clipboardData.getData('Text');// || window.clipboardData.getData('Text');
            var strValidChars = "+0123456789";
            var strChar;
            var FilteredChars = "";
            for (var i = 0; i < totalCharacterCount.length; i++) {
                strChar = totalCharacterCount.charAt(i);
                if (strValidChars.indexOf(strChar) != -1) {
                    FilteredChars = FilteredChars + strChar;
                }
            }

			if (field2 && field3) {
				this[field][field2][field3] = FilteredChars
			}
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex < 3) {
            if (rowIndex % 2 === 0) {
            return {
                rowspan: 2,
                colspan: 1
            };
            } else {
            return {
                rowspan: 0,
                colspan: 0
            };
            }
        }

        if (columnIndex === 7) {
            if (rowIndex % 2 === 0) {
            return {
                rowspan: 2,
                colspan: 1
            };
            } else {
            return {
                rowspan: 0,
                colspan: 0
            };
            }
        }
      },
      objectSpanMethodSummary({ row, column, rowIndex, columnIndex }) {
        if (columnIndex < 1) {
            if (rowIndex % 7 === 0) {
            return {
                rowspan: 7,
                colspan: 1
            };
            } else {
            return {
                rowspan: 0,
                colspan: 0
            };
            }
        }
      },
        doDeleteMetaGoal(val){
            this.$confirm("Delete this data meta goals?", 'Confirmation', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                type: 'info',
                center: true
			}).then(async () => {
                await api({
				url:config.baseApi+'bussiness/delete-meta-goals',
				method:'DELETE',
				data:{
                    item: val
				}
			}).then(resp => {
                    if(resp.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
                    } else {
                        this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
                        // this.dialogAddData = false
                        // this.clear()
                        this.paginateMetaGoals(1)
                    }
                }).catch(err => {
                    this.$swal(this.$t('error'), this.$t('error_text'), "error").then()
                    this.paginateMetaGoals(1)
                })
            }).catch(cancel => {

            })
        },
        doShowDialogEditMetaGoal(val){
            this.tableDataMetaGoalsEdit = val.meta_goals || []
            if (this.tableDataMetaGoalsEdit.length > 0) {
              this.tableDataMetaGoalsEdit =  this.tableDataMetaGoalsEdit.map(el => {
                    if ((''+el.revenue).split('.')[1] == "0000") {
                        el.revenue = parseInt(el.revenue)
                    }
                    return el
                })
            }
            else {
                let tempData = []
                let quarter = 1
                let half = 1
                this.optionsMonths.forEach((el,i) => {
                    let obj = {
                        goal_name: el.label,
                        conversation:"",
                        revenue: "",
                        active_waba: "",
                        active_number: ""
                    }

                    tempData.push(obj)
                })

                this.tableDataMetaGoalsEdit = [...tempData]

                for (let index = 1; index <= tempData.length; index++) {
                if((index) % 4 == 0){
                        this.tableDataMetaGoalsEdit.splice(index-1,0 , {
                            goal_name: `Quarter ${quarter}`,
                            conversation:"",
                            revenue: "",
                            active_waba: "",
                            active_number: "",
                        })

                        if ((index) % 8 == 0) {
                            this.tableDataMetaGoalsEdit.splice(index,0 , {
                                    goal_name: `H${half}`,
                                    conversation:"",
                                    revenue: "",
                                    active_waba: "",
                                    active_number: ""
                            })

                            half++
                        }

                        quarter++
                    }

                    if (index == 12) {
                        this.tableDataMetaGoalsEdit.push({
                            goal_name: `Quarter ${quarter}`,
                            conversation:"",
                            revenue: "",
                            active_waba: "",
                            active_number: ""
                        })

                        this.tableDataMetaGoalsEdit[index].sort = index + 1

                        this.tableDataMetaGoalsEdit.push({
                                    goal_name: `H${half}`,
                                    conversation:"",
                                    revenue: "",
                                    active_waba: "",
                                    active_number: ""
                            })
                    }
                    
                }

                this.tableDataMetaGoalsEdit.map((v,id) => {
                    v.sort = id + 1
                    return v
                })
            }
            this.dialogEditData = true

        },
        checkYear(year){
            let result = moment().format("YYYY") == year ? true : false

            return result
        },
        async addDataMetaGoals(){
            let year = moment().format("YYYY")
            let checkField = false
            this.tableDataMetaGoalsAdd.forEach(el => {
                if (!el.conversation || !el.revenue || !el.active_waba || !el.active_number) {
                    checkField = true
                }
            })

            if(this.tableDataMetaGoalsAdd.length === 0 || checkField){
                this.$message.error({
                    showClose: false,
                    message: 'All field is required'
                });
                return
            }

			this.loadingBtn = true
			var self = this
			await api({
				url:config.baseApi+'bussiness/add-meta-goals',
				method:'POST',
				data:{
					year: year,
                    goals: this.tableDataMetaGoalsAdd
				}
			}).then(response => {
                this.dialogAddData = false
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
					// this.dialogAddData = false
					this.clear()
					this.paginateMetaGoals(1)
				}
				this.loadingBtn = false
			}).catch(error => {
                this.dialogAddData = false
                this.$swal(this.$t('error'), this.$t('error_text'), "error")
                this.loadingBtn = false
				return error
			})
        },
        async editDataMetaGoals(){
            let year = moment().format("YYYY")
            let checkField = false
            this.tableDataMetaGoalsEdit.forEach(el => {
                if (!el.conversation || !el.revenue || !el.active_waba || !el.active_number) {
                    checkField = true
                }
            })

            if(this.tableDataMetaGoalsEdit.length === 0 || checkField){
                this.$message.error({
                    showClose: false,
                    message: 'All field is required'
                });
                return
            }

			this.loadingBtn = true
			var self = this
			await api({
				url:config.baseApi+'bussiness/edit-meta-goals',
				method:'POST',
				data:{
					// year: year,
                    meta_goals: this.tableDataMetaGoalsEdit
				}
			}).then(response => {
                this.dialogEditData = false
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
					this.$swal(this.$t('success'), this.$t('success'), "success").then(this.clear())
					// this.dialogEditData = false
					this.clear()
					this.paginateMetaGoals(1)
				}
				this.loadingBtn = false
			}).catch(error => {
                this.dialogEditData = false
                this.$swal(this.$t('error'), this.$t('error_text'), "error")
                this.loadingBtn = false
                this.paginateMetaGoals(1)
				return error
			})
        },
        addMetaGoals(){
            this.tableDataMetaGoalsAdd = []
            let tempData = []
            let quarter = 1
            let half = 1
            this.optionsMonths.forEach((el,i) => {
                let obj = {
                    goal_name: el.label,
                    conversation:"",
                    revenue: "",
                    active_waba: "",
                    active_number: ""
                }

                tempData.push(obj)
            })

            this.tableDataMetaGoalsAdd = [...tempData]

            for (let index = 1; index <= tempData.length; index++) {
               if((index) % 4 == 0){
                    this.tableDataMetaGoalsAdd.splice(index-1,0 , {
                        goal_name: `Quarter ${quarter}`,
                        conversation:"",
                        revenue: "",
                        active_waba: "",
                        active_number: "",
                    })

                    if ((index) % 8 == 0) {
                        this.tableDataMetaGoalsAdd.splice(index,0 , {
                                goal_name: `H${half}`,
                                conversation:"",
                                revenue: "",
                                active_waba: "",
                                active_number: ""
                        })

                        half++
                    }

                    quarter++
                }

                if (index == 12) {
                    this.tableDataMetaGoalsAdd.push({
                        goal_name: `Quarter ${quarter}`,
                        conversation:"",
                        revenue: "",
                        active_waba: "",
                        active_number: ""
                    })

                     this.tableDataMetaGoalsAdd[index].sort = index + 1

                    this.tableDataMetaGoalsAdd.push({
                                goal_name: `H${half}`,
                                conversation:"",
                                revenue: "",
                                active_waba: "",
                                active_number: ""
                        })
                }
                
            }

            this.tableDataMetaGoalsAdd.map((v,id) => {
                v.sort = id + 1
                return v
            })
            

            
            this.dialogAddData = true
        },
        clear(){
            this.tableDataMetaGoalsAdd = []
        },
        paginateMetaGoals(page){
            this.getMetaGoals(page)
        },
        async loadReportQuickSummary(){

            // if (!this.selectedField || !this.selectedMessageTypeField || !this.selectedFilter) {
            //     this.$message.error({
            //         showClose: false,
            //         message: 'All field filter is required'
            //     });
            //     return
            // }
            // this.tableDataSummary = []

            this.loadingBtnSummary = true
			let custId = this.$route.params.consumen
			let apiOptions = {
                url: config.baseApi+ "bussiness/get-dashboard-quick-summary",
                method: 'get',
                // params: {
                //     // page: page,
                //     type: this.selectedMessageTypeField,
                //     filter: this.selectedFilter,
                //     year: this.selectedField
                // }
            }

            await api(apiOptions)
            .then(res => {
                    // var dt
                if(res.data.ec == 200){
                    let datas = res.data.data? res.data.data : []
                    let tempArray = []
                    let description = ["META-Conversation", "DKD_Conversation", "META-Revenue-Conversation", "DKD-Revenue-Conversation", "Active Waba", "Active Number", "Traffic"]
                    let meta_conversation = {
                        Q_1 : 0,
                        Q_2 : 0,
                        H_1 : 0,
                        Q_3 : 0,
                        Q_4 : 0,
                        H_2: 0
                    }

                    let dkd_conversation = {
                        Q_1 : 0,
                        Q_2 : 0,
                        H_1 : 0,
                        Q_3 : 0,
                        Q_4 : 0,
                        H_2: 0
                    }

                    let meta_revenue = {
                        Q_1 : 0,
                        Q_2 : 0,
                        H_1 : 0,
                        Q_3 : 0,
                        Q_4 : 0,
                        H_2: 0
                    }

                    let dkd_revenue = {
                        Q_1 : 0,
                        Q_2 : 0,
                        H_1 : 0,
                        Q_3 : 0,
                        Q_4 : 0,
                        H_2: 0
                    }

                    let active_waba = {
                        Q_1 : 0,
                        Q_2 : 0,
                        H_1 : 0,
                        Q_3 : 0,
                        Q_4 : 0,
                        H_2: 0
                    }

                    let active_number = {
                        Q_1 : 0,
                        Q_2 : 0,
                        H_1 : 0,
                        Q_3 : 0,
                        Q_4 : 0,
                        H_2: 0
                    }

                    let traffic = {
                        Q_1 : 0,
                        Q_2 : 0,
                        H_1 : 0,
                        Q_3 : 0,
                        Q_4 : 0,
                        H_2: 0
                    }

                    if (Array.isArray(datas)) {
                        datas.forEach((el, i) => {
                            if (el.quick_summaries && el.quick_summaries.length > 0) {
                                let basicObj = {
                                    no: i+1,
                                    year: el.year
                                }

                                el.quick_summaries.forEach((v) => { 
                                    meta_conversation[v.column_name] = Number(v.meta_conversation || 0)
                                    dkd_conversation[v.column_name] = Number(v.dkd_conversation || 0)
                                    meta_revenue[v.column_name] = this.formatPrice(Number(v.meta_revenue || 0))
                                    dkd_revenue[v.column_name] = this.formatPrice(Number(v.dkd_revenue || 0))
                                    active_waba[v.column_name] = Number(v.active_waba || 0)
                                    active_number[v.column_name] = Number(v.active_number || 0)
                                    traffic[v.column_name] = Number(v.traffic || 0)
                                })

                                description.forEach((val) => {
                                    switch (val) {
                                        case "META-Conversation":
                                            basicObj.description = val
                                            tempArray.push({
                                                ...basicObj, ...meta_conversation
                                            })
                                            break;
                                        case "DKD-Conversation":
                                            basicObj.description = val
                                            tempArray.push({
                                                ...basicObj, ...dkd_conversation
                                            })
                                            break;
                                        case "META-Revenue-Conversation":
                                            basicObj.description = val
                                            tempArray.push({
                                                ...basicObj, ...meta_revenue
                                            })
                                            break;
                                        case "DKD-Revenue-Conversation":
                                            basicObj.description = val
                                            tempArray.push({
                                                ...basicObj, ...dkd_revenue
                                            })
                                            break;
                                        case "Active Waba":
                                            basicObj.description = val
                                            tempArray.push({
                                                ...basicObj, ...active_waba
                                            })
                                            break;
                                        case "Active Number":
                                            basicObj.description = val
                                            tempArray.push({
                                                ...basicObj, ...active_number
                                            })
                                            break;
                                        case "Traffic":
                                            basicObj.description = val
                                            tempArray.push({
                                                ...basicObj, ...traffic
                                            })
                                            break;
                                    }
                                })
                            }
                            else{
                                tempArray.push({
                                    no: i+1,
                                    year: el.year,
                                    description: null
                                })
                            }
                        })
                    }

                        this.tableDataSummary = tempArray

                }
                this.loadingBtnSummary = false
            })
            .catch(error => {
                this.loadingBtnSummary = false
                console.log("error report quick summary", error);
				this.$swal(this.$t('error'), error.message, "error")
            })
            // this.loadingBtnSummary = false
        },
        async getMetaGoals(page = 1){

            this.loadingReportTable = true
			let apiOptions = {
                url: config.baseApi+ "bussiness/get-meta-goals",
                method: 'get',
                params: {
                    page: page,
                }
            }

            await api(apiOptions)
            .then(res => {
                    // var dt
                if(res.data.ec == 200){
                    this.meta_goal_data = res.data.data.data || []
                    this.totalMetaGoals = res.data.data.total || 0
                    // this.tableDataMetaGoals = this.meta_goal_data.meta_goals || []

                    if (this.meta_goal_data.length === 0) {
                        this.meta_goal_data = [{year: moment().format("YYYY"), disabled: true}]
                    }
                }
                this.loadingReportTable = false
            })
            .catch(error => {
                this.loadingReportTable = false
                console.log("error meta goals", error);
				this.$swal(this.$t('error'), error.message, "error")
            })
            // this.loadingReportTable = false
        },
        async downloadBilling(query = ""){
            if (!this.selectedField || !this.selectedMessageTypeField || !this.selectedFilter) {
                this.$message.error({
                    showClose: false,
                    message: 'All field filter is required'
                });
                return
            }

            this.loadingReportDownload = true
			let apiOptions = {
                url: config.baseApi+ "bussiness/get-summary-billing",
                method: 'post',
                params: {
                    // page: page,
                    type: this.selectedMessageTypeField,
                    filter: this.selectedFilter,
                    year: this.selectedField
                },
                timeout: (10 * 60) * 1000
            }

            if(query == "download"){
				apiOptions.responseType = "arraybuffer"
                apiOptions.params.download = true
            }

            await api(apiOptions)
            .then(res => {
                    // var dt
                if(query == "download"){
                    if(res.headers['content-type'].indexOf('application/json') == -1){
                        try {
                            const url = window.URL.createObjectURL(new Blob([res.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', `Report Billing (${this.selectedField}-${this.selectedFilter}).xlsx`); //or any other extension
                            link.click();
                        } catch(err){
                            console.log(err)
                        }
                    } else{
                        this.$swal(this.$t('error'), `${res.data.message}`, "error")
                    }
                }
                this.loadingReportDownload = false
            })
            .catch(error => {
                this.loadingReportDownload = false
                console.log("error report download", error);
				this.$swal(this.$t('error'), error.message, "error")
            })
            // this.loadingReportTable = false
        },
        async loadReportMeta(){

            if (!this.selectedField || !this.selectedMessageTypeField || !this.selectedFilter) {
                this.$message.error({
                    showClose: false,
                    message: 'All field filter is required'
                });
                return
            }

            this.loadingReportTable = true
			let custId = this.$route.params.consumen
			let apiOptions = {
                url: config.baseApi+ "bussiness/get-dashboard-meta",
                method: 'get',
                params: {
                    // page: page,
                    type: this.selectedMessageTypeField,
                    filter: this.selectedFilter,
                    year: this.selectedField
                }
            }

            await api(apiOptions)
            .then(res => {
                    // var dt
                if(res.data.ec == 200){
                    this.dataDashboardMeta = res.data.data.data ? res.data.data.data : this.dataDashboardMeta
                    // if (Array.isArray(res.data.data)) {
                    //     this.tableData = res.data.data
                    // }
                    // else{
                    //     this.tableData = res.data.data.data
                    // }
                }
                this.loadingReportTable = false
            })
            .catch(error => {
                this.loadingReportTable = false
                console.log("error report meta", error);
				this.$swal(this.$t('error'), error.message, "error")
            })
            // this.loadingReportTable = false
        },
        async loadReportMetaGoals(){

            if (!this.selectedField || !this.selectedMessageTypeField || !this.selectedFilter) {
                this.$message.error({
                    showClose: false,
                    message: 'All field filter is required'
                });
                return
            }

            this.tableDataReportList = []
            this.loadingReportTable = true
			let custId = this.$route.params.consumen
			let apiOptions = {
                url: config.baseApi+ "bussiness/get-dashboard-meta-goals",
                method: 'get',
                params: {
                    // page: page,
                    type: this.selectedMessageTypeField,
                    filter: this.selectedFilter,
                    year: this.selectedField
                }
            }

            await api(apiOptions)
            .then(res => {
                    // var dt
                if(res.data.ec == 200){
                    this.dataDashboardMetaGoals = res.data.data.id ? res.data.data : this.dataDashboardMetaGoals
                    let target = {
                        conversation_total : 0,
                        revenue_total : 0,
                        waba_active : 0,
                        phone_number_active : 0
                    }

                    if (this.dataDashboardMetaGoals.meta_goals.length > 0) {
                        this.dataDashboardMetaGoals.meta_goals.forEach(el => {
                            target.conversation_total += Number(el.conversation)
                            target.revenue_total += Number(el.revenue)
                            target.waba_active += Number(el.active_waba)
                            target.phone_number_active += Number(el.active_number)
                        })
                    }

                    for (const key in target) {
                        let status = null
                        if (target.hasOwnProperty(key) && this.dataDashboardMeta.hasOwnProperty(key)) {
                            if (Number(this.dataDashboardMeta[key]) >= Number(target[key])) {
                                status = "Achieved"
                            }
                            else if (Number(this.dataDashboardMeta[key]) < Number(target[key])){
                                status = "FAILED"
                            }

                            this.tableDataReportList.push({
                                status : status,
                                description: `${key.charAt(0).toUpperCase()+key.slice(1)} Target ${ key == 'revenue_total' ? this.formatPrice(target[key]): target[key]}`
                            })
                        }
                    }

                    // if (Array.isArray(res.data.data)) {
                    //     this.tableData = res.data.data
                    // }
                    // else{
                    //     this.tableData = res.data.data.data
                    // }
                }
                this.loadingReportTable = false
            })
            .catch(error => {
                this.loadingReportTable = false
                console.log("error report meta goals", error);
				this.$swal(this.$t('error'), error.message, "error")
            })
            // this.loadingReportTable = false
        },
        async loadReportDKD(){

            if (!this.selectedField || !this.selectedMessageTypeField || !this.selectedFilter) {
                this.$message.error({
                    showClose: false,
                    message: 'All field filter is required'
                });
                return
            }

            this.loadingReportTableDKD = true
			let custId = this.$route.params.consumen
			let apiOptions = {
                url: config.baseApi+ "bussiness/get-dashboard-dkd",
                method: 'get',
                params: {
                    // page: page,
                    type: this.selectedMessageTypeField,
                    filter: this.selectedFilter,
                    year: this.selectedField
                }
            }

            await api(apiOptions)
            .then(res => {
                    // var dt
                if(res.data.ec == 200){

                    this.dataDashboardDKD = res.data.data.data
                    // if (Array.isArray(res.data.data)) {
                    //     this.tableData = res.data.data
                    // }
                    // else{
                    //     this.tableData = res.data.data.data
                    // }
                }
                this.loadingReportTableDKD = false
            })
            .catch(error => {
                this.loadingReportTableDKD = false
                console.log("error report dkd", error);
				this.$swal(this.$t('error'), error.message, "error")
            })
            // this.loadingReportTable = false
        },
        async loadReportChatbotOmni(){

            if (!this.selectedField || !this.selectedMessageTypeField || !this.selectedFilter) {
                this.$message.error({
                    showClose: false,
                    message: 'All field filter is required'
                });
                return
            }

            this.loadingReportTable = true
			let custId = this.$route.params.consumen
			let apiOptions = {
                url: config.baseApi+ "bussiness/get-dashboard-dkd-omni-chatbot",
                method: 'get',
                params: {
                    // page: page,
                    type: this.selectedMessageTypeField,
                    filter: this.selectedFilter,
                    year: this.selectedField
                }
            }

            await api(apiOptions)
            .then(res => {
                    // var dt
                if(res.data.ec == 200){
                    this.dataDashboardChatbotOmni = res.data.data
                    // if (Array.isArray(res.data.data)) {
                    //     this.tableData = res.data.data
                    // }
                    // else{
                    //     this.tableData = res.data.data.data
                    // }
                }
                this.loadingReportTable = false
            })
            .catch(error => {
                this.loadingReportTable = false
                console.log("error report chat omni", error);
				this.$swal(this.$t('error'), error.message, "error")
            })
            // this.loadingReportTable = false
        },
        async changeFilter() {
            this.currentPage = 1
            // this.loadReportDKD = true
			await this.loadReportMeta()
            this.loadReportDKD()
            this.loadReportMetaGoals()
            this.loadReportChatbotOmni()
            // this.loadReportDKD()
		},
        handleChangeType(val){
            // this.loadingReportTable = true
            switch (val) {
                case "monthly":
                    this.filterBy = this.optionsMonths
                    this.selectedFilter = moment().format("MM")
                    if (parseInt(moment().format("MM")) <= parseInt(this.selectedFilter)){
                        this.btnDownload = false
                    }
                    else{
                        this.btnDownload = true
                    }
                    break;
                case "quarter_years":
                    this.btnDownload = false
                    this.filterBy = [
                        { value: "1", label: "Q1" },
                        { value: "2", label: "Q2" },
                        { value: "3", label: "Q3" },
                        { value: "4", label: "Q4" }
                    ]

                    this.selectedFilter = "1"
                    break;
                case "half_years":
                    this.btnDownload = false
                    this.filterBy = [
                        { value: "1", label: "H1" },
                        { value: "2", label: "H2" }
                    ]
                    this.selectedFilter = "1"
                    break;
                default:
                    break;
            }

        },
        handleChangeFilter(val){
            if (this.selectedMessageTypeField == 'monthly') {
                if (parseInt(moment().format("MM")) <= parseInt(val) ){
                    this.btnDownload = false
                }else{
                    this.btnDownload = true
                }
            }
            else{
                this.btnDownload = false
            }
        },
		maintenance () {
			alert("Under maintenance")
		},
		mapingRomawi(date){
			let month = parseInt(moment(date).format('M'))
			let lookup = {M:1000,CM:900,D:500,CD:400,C:100,XC:90,L:50,XL:40,X:10,IX:9,V:5,IV:4,I:1},
				roman = '',
				i;
			for ( i in lookup ) {
				while ( month >= lookup[i] ) {
				roman += i;
				month -= lookup[i];
				}
			}
			return roman;
		},
		tabClick(tab){
			 if(tab.name == "index"){
		
			} else if(tab.name == "set_meta_goal"){
				this.getMetaGoals()
			} 
        },
		formatDate(val, format){
            return moment(val).format(format)
		},
		totalBill(){
			this.totalBilling = this.formatPrice(this.totalCbp+this.totalUi+this.totalBi)
		},
		formatPrice(value) {
            // let val = (value/1).toFixed(2).replace('.', ',')
            if(typeof value == "string") value = parseFloat(value)

            if(value == null || value == "") value = 0
			return value.toLocaleString('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: Number.isInteger(value) ? 0 : 4 })
		},
		formatNumber(value) {
            // let val = (value/1).toFixed(2).replace('.', ',')
            if(typeof value == "string") value = parseFloat(value)

            if(value == null || value == "") value = 0
			return value.toLocaleString('id-ID', { minimumFractionDigits: Number.isInteger(value) ? 0 : 4 })
		},
		capitalizeFirstLetter(string) {
			if(string == null || string == ""){
				return "-"
			} else {
				return string.charAt(0).toUpperCase() + string.substring(1);
			}
		}
    },
   	async mounted(){

        let start = moment().startOf('year')
        let end = moment().endOf('year')

        while (moment(start) <= moment(end)) {
            let data = {
				value: moment(start).format("MM"),
				label: moment(start).format("MMMM")
			}

            this.optionsMonths.push(data)
            start = moment(start).add(1, 'month')
        }

        this.filterBy = this.optionsMonths

        for(let i = 2; i >= 0; i--){
			// console.log("a", moment().subtract(i, 'month').format("MM YYYY"))
            let data = {
				value: moment().subtract(i, 'year').format("YYYY"),
				label: moment().subtract(i, 'year').format("YYYY")
			}

			this.searchFields.push(data) 
		}

        // this.loadReportDKD = true
        await this.loadReportQuickSummary()
        await this.loadReportMeta()
        this.loadReportDKD()
        this.loadReportMetaGoals()
        this.loadReportChatbotOmni()
        
    },
	watch: {
        // dataMeta: function() {
        //     this.dataDashboardMeta = this.dataMeta
        // },
        loadingData: function() {
           this.loadingBtn = this.loadingData          
        },
        date: function() {
            this.selectedStartDateDashboard = this.date
        }
    },
}
</script>
<style scoped>

/* .cell-custom{
    padding: 0px !important;
} */
.wa-number {
    font-size: 11px;
}

/* .el-table th.is-leaf, .el-table td {
    border-bottom: none !important;
} */

.pd-item{
    padding-left: 17px;
    font-size: 11px;
}

.swal2-container {
	z-index: 10000 !important;
}

.img-center {
    display: block;
    margin-bottom: 0px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
    width: 50%;
}

table {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #ffffff;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}
table th {
  background: #79DFFF;
  color: black;
  font-weight: bold;
  /* font-size: 18px; */
}
/* .css-serial { */
  /* counter-reset: serial-number;  Atur penomoran ke 0 */
/* } */
/* .css-serial td:first-child:before { */
  /* counter-increment: serial-number;  Kenaikan penomoran */
  /* content: counter(serial-number);  Tampilan counter */
/* } */
</style>
<style lang="scss">
@import '../../assets/scss/_variables';

.el-table::before {
    background-color:#FFFFFF;
}

.el-table__fixed::before, .el-table__fixed-right::before {
     background-color:#FFFFFF;
}

.el-table .cell {
    padding-left: 0;
    padding-right: 0;
}

.clearfix:before,
.clearfix:after {
display: table;
content: "";
}
.clearfix:after {
clear: both
}

.el-card__header {
    padding: 10px 20px;
}

.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}

.row {
	margin-top: 30px;
}

.page-invoice {
	.toolbar {
		max-width: 794px;
		margin: 0 auto;
		text-align: right;
		margin-bottom: 20px;
	}

	.invoice {
		background: white;
		width: 100%;
		max-width: 794px;
		min-height: 1123px;
		margin: 0 auto;
		padding: 2em;
		box-sizing: border-box;
		box-shadow: 0px 8px 8px -8px rgba(0, 0, 0, 0.3);

		hr {
			border: 1px solid rgba(0, 0, 0, 0.05);
		}

		.invoice-top {
			overflow: hidden;
			float: right;
			margin-bottom: 30px;

			.logo {
				float: right;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				border-radius: 50%;
				overflow: hidden;
				background: rgba(0, 0, 0, 0.07);
				text-align: center;

				img {
					height: 80%;
					margin-top: 10%;
				}
			}
			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}
			.title {
				float: right;

				& > * {
					margin: 0;
				}

				p {
					text-align: right;
				}
			}
		}

		.invoice-middle {
			overflow: hidden;
			margin-top: 30px;
			margin-bottom: 30px;

			.clientlogo {
				float: left;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				border-radius: 50%;
				overflow: hidden;
				background: grey;

				img {
					width: 100%;
				}
			}

			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}

			.project {
				margin-left: 52%;

				& > * {
					margin: 0;
				}
			}
		}

		.invoice-bottom {
			table {
				width: 100%;
				border-collapse: collapse;

				th {
					text-align: right;
					padding: 20px;
					padding-bottom: 5px;
					opacity: .7;

					&:first-child {
						text-align: left;
						padding-left: 0px;
						// width: 100%
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				td {
					text-align: right;
					padding: 20px;
					padding-bottom: 5px;
					border-bottom: 1px solid #EEE;

					&:first-child {
						text-align: left;
						padding-left: 0px;
						// width: 100%;
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				tfoot td {
					border: none;
					padding-top: 5px;
				}
			}
		}

		h1 { font-size: 1.5em; color: #222; }
		h2 { font-size: .9em; }
		h3 { font-size: 1.2em; font-weight: 300; line-height: 2em; }
		p  { font-size: .7em; color: #666; line-height: 1.2em; }
	}

}


@media print{
	.layout-container .container .footer ,
	.layout-container .container .header ,
	.layout-container .container .horizontal-nav ,
	.layout-container .footer ,
	.layout-container .layout-picker ,
	.layout-container .vertical-nav ,
	.layout-container .header {
		display:none;
	}
}
</style>
